import { datadogRum } from '@datadog/browser-rum';
import { dataLayerService } from './dataLayerService';

interface userConfig {
  applicationId?: string;
  clientToken?: string;
  serviceName?: string;
}

const RELEASE_VERSION = import.meta.env['VITE_RELEASE_VERSION'] || 'unknown';

export function datadogRumPlugin(userConfig: userConfig) {
  return {
    name: 'datadog-rum',
    initialize: ({ config }) => {
      datadogRum.init({
        applicationId: userConfig.applicationId!,
        clientToken: userConfig.clientToken!,
        site: 'datadoghq.com',
        service: userConfig.serviceName!,
        env: import.meta.env.MODE,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        trackSessionAcrossSubdomains: true,
        version: RELEASE_VERSION,
        // Propagators pinned (instead of SDK defaults) so the exact set of injected
        // request headers stays in lockstep with the unified API's CORS
        // Access-Control-Allow-Headers allowlist — an SDK upgrade that adds a new
        // default propagator would otherwise fail every preflight.
        allowedTracingUrls: [
          import.meta.env['VITE_UNIFIED_API_URL'],
          import.meta.env['VITE_CHECKOUT_ORCHESTRATOR_URL'],
          import.meta.env['VITE_OFFER_ORCHESTRATOR_URL'],
          import.meta.env['VITE_SPICEROAD_URL'],
        ]
          .filter(Boolean)
          .map((url: string) => ({ match: url, propagatorTypes: ['datadog', 'tracecontext'] as const })),
        propagateTraceBaggage: true,
      });
    },
    page: ({ payload }) => {
      datadogRum.startView(payload.properties.url);
    },
    track: ({ payload }) => {
      datadogRum.addAction(payload.event, payload.properties);
    },
    identify: ({ payload }) => {
      if (payload.traits) {
        dataLayerService.updateDataLayer(payload.traits);
        datadogRum.setUser(dataLayerService.getDataLayer());
      }
    },
    methods: {
      trackError: (error, context) => {
        datadogRum.addError(error, context);
      }
    },
  };
}

export default datadogRumPlugin;
